import React, { useState } from "react";
import { Button } from "../../../../../components";
import CreateManuval from "./AddLca/CreateManuval";

const AddLca = ({setCreateManuval,createManuval,editData}) => {
  
  const handleCancel = () => {
    setCreateManuval(false);
  };
  return (
    <div>
      {!createManuval ? (
        <div className="flex flex-col items-center gap-4 p-10">
          <h3>Add LCA</h3>
          <div className="flex gap-6 mt-10">
            <Button title={"Upload LCA Parsing"} />
            <Button
              title={"Create Manuval"}
              onClick={() => setCreateManuval(true)}
            />
          </div>  
        </div>
      ) : (
        <CreateManuval onCancel={handleCancel} editData={editData}/>
      )}
    </div>
  );
};

export default AddLca;
